module.exports = __webpack_public_path__ + "img/restaurant_bodyimage04.9ace23d2.jpg";